//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { updateLike2BuyV2StoreConfig } from '@apis/like2buy-v2/like2BuyV2CustomizationsApi';
import { findLike2BuyV2Stores } from '@apis/like2buy-v2/like2BuyV2StoreApi';
import { ILike2BuyV2InstagramDefaultV1Config } from '@apis/like2buy-v2/like2BuyV2StoreModel';
import { isInstagramLike2BuyV2Template } from '@instagram-account/like2buy-v2/utils/instagramLike2BuyV2CustomizationsUtils';
import { getConnectedInstagramBusinessAccountIdAsNetworkUserId } from '@instagram-account/redux/selectors/getInstagramBusinessAccountIdAsNetworkUserId';
import { SocialNetwork } from '@models/SocialNetwork';
import angular, { IHttpService } from 'angular';

const REST_API_BASE = '/api/v2/like2buy/customize';

export default class CustomizeLike2buyService {
  constructor(
    private $ngRedux,
    private $http: IHttpService,
    private $upload,
    private promiseService,
  ) {}

  public getLike2buyImplAsync = () => {
    return this.promiseService.processHttpResponse(
      this.$http.get(`${REST_API_BASE}`),
    );
  };

  public updateLike2BuyCustomizationsAsync = async (
    implId,
    tributaryName,
    squareCropConfig,
    emailCaptureConfig,
    posterImageConfig,
    customStringsConfig,
    previewUrl,
    previewImplId,
    isPreview,
    digestedImages, // TODO PD-245819: Clean up dual write
  ) => {
    const params = {
      implId,
      tributaryName,
      squareCropConfig,
      emailCaptureConfig,
      posterImageConfig,
      customStringsConfig,
      previewUrl,
      previewImplId,
      isPreview,
      digestedImages, // TODO PD-245819: Clean up dual write
    };

    // TODO PD-245819: Clean up dual write
    const state = this.$ngRedux.getState();
    const networkUserId =
      getConnectedInstagramBusinessAccountIdAsNetworkUserId(state);

    const stores = await findLike2BuyV2Stores({
      includeDisabled: false,
      network: SocialNetwork.Instagram,
      networkUserId,
    });

    if (stores?.[0]) {
      const store = stores[0];
      if (isInstagramLike2BuyV2Template(store.config)) {
        const newConfig: ILike2BuyV2InstagramDefaultV1Config = {
          ...store.config,
          customStringsByLocale: {
            ...store.config.customStringsByLocale,
            'en-us': {
              ...store.config.customStringsByLocale['en-us'],
              gallery: {
                ...store.config.customStringsByLocale['en-us']?.gallery,
                ctaBanner:
                  customStringsConfig?.mobileGalleryHeader ??
                  store.config.customStringsByLocale['en-us']?.gallery
                    ?.ctaBanner,
                desktopCtaBanner:
                  customStringsConfig?.desktopGalleryHeader ??
                  store.config.customStringsByLocale['en-us']?.gallery
                    ?.desktopCtaBanner,
                emailCapture: {
                  ...store.config.customStringsByLocale['en-us']?.gallery
                    ?.emailCapture,
                  cta:
                    emailCaptureConfig?.callToAction ??
                    store.config.customStringsByLocale['en-us']?.gallery
                      ?.emailCapture?.cta,
                },
                header: {
                  ...store.config.customStringsByLocale['en-us']?.gallery
                    ?.header,
                  bannerSection: {
                    ...store.config.customStringsByLocale['en-us']?.gallery
                      ?.header?.bannerSection,
                    destinationUrl:
                      posterImageConfig?.posterPassthroughUrl ??
                      store.config.customStringsByLocale['en-us']?.gallery
                        ?.header?.bannerSection?.destinationUrl,
                  },
                },
              },
              items: {
                ...store.config.customStringsByLocale['en-us']?.items,
                products: {
                  ...store.config.customStringsByLocale['en-us']?.items
                    ?.products,
                  header:
                    customStringsConfig.multiproductHeader ??
                    store.config.customStringsByLocale['en-us']?.items?.products
                      ?.header,
                },
              },
            },
          },
          galleryBannerSection: {
            ...store.config.galleryBannerSection,
            imageFileId:
              digestedImages?.imageFileId ??
              store.config.galleryBannerSection?.imageFileId,
            imageFileName:
              digestedImages?.imageFileName ??
              store.config.galleryBannerSection?.imageFileName,
            desktopImageFileId:
              digestedImages?.desktopImageFileId ??
              store.config.galleryBannerSection?.desktopImageFileId,
            desktopImageFileName:
              digestedImages?.desktopImageFileName ??
              store.config.galleryBannerSection?.desktopImageFileName,
            isEnabled:
              posterImageConfig?.isEnabled ??
              store.config.galleryBannerSection?.isEnabled,
          },
          galleryEmailCapture: {
            ...store.config.galleryEmailCapture,
            isEnabled:
              emailCaptureConfig?.isEnabled ??
              store.config.galleryEmailCapture?.isEnabled,
            shouldRequireTermsAndConditions:
              store.config.galleryEmailCapture
                ?.shouldRequireTermsAndConditions ?? false,
          },
          gallerySquareThumbnails: squareCropConfig,
        };

        await updateLike2BuyV2StoreConfig({
          storeId: store.id,
          body: newConfig,
        });
      }
    }
    /* ------- */

    return this.$http.put(`${REST_API_BASE}`, params);
  };

  public uploadCustomBanner = (
    file,
    tributaryName,
    currentVersion,
    forMobile,
  ) => {
    const version = currentVersion + 1;
    return this.promiseService.processHttpResponse(
      this.$upload.upload({
        url: `${REST_API_BASE}/upload-poster`,
        method: 'POST',
        file,
        params: {
          tributaryName,
          version,
          forMobile,
        },
      }),
    );
  };
}

angular.module('curalate').service('CustomizeLike2buyService', [
  '$ngRedux', // TODO PD-245819: Clean up dual write
  '$http',
  '$upload',
  'PromiseService',
  CustomizeLike2buyService,
]);
